import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Company } from './interfaces/company';
import { Place } from './interfaces/place';
import { Filter } from './interfaces/experiences';
import { resource } from 'app/utils/resource/old';

export interface WineryShortDto {
  id: string;
  businessName: string;
  cf: string;
  city: string;
}

export interface WineryShortResponseDto {
  data: WineryShortDto[];
  page: number;
  size: number;
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(private http: HttpClient) { }

  getCompany(companyId?: string): Observable<Company> {
     // Mock `place` object following the `Place` interface structure
     const mockPlace: Place = {
      lat: '40.712776',
      lng: '-74.005974',
      street: '123 Main St',
      city: 'New York',
      zipcode: '10001',
      province: 'NY',
      state: 'New York',
      region: 'Northeast'
    };

    return of({
      id: '1',
      name: 'Cantina Corporation',
      description: 'test company',
      opening_hours: '9:00 AM - 6:00 PM',
      nearby_cities: 'Los Angeles, San Francisco',
      meta_title: 'Mock Company Meta Title',
      meta_description: 'Mock Company Meta Description',
      paypal_client_id: companyId || 'mock-paypal-id',
      show_widget_filters: false,
      nexi_merchant: '',
      nexi_chiavemac: '',
      created_at: '2024-01-01T00:00:00Z',
      updated_at: '2024-01-01T00:00:00Z',
      max_experience_title_length: 100,
      place: mockPlace  // Assign the mocked `place` object here
    });

    //return resource('divineaCom://companies')
    //.get<Company[]>
  }

  getWineryCompany(filter: Filter): Observable<Company[]> {
    return resource('wsb2c://winery')
      .post<WineryShortResponseDto>({ page: filter.page, size: filter.size, lang: filter.lang })
      .pipe(map((response) => (response?.data ?? []).map((dto) => this.mapWineryShortToCompany(dto))));
  }

  private mapWineryShortToCompany(dto: WineryShortDto): Company {
    return {
      id: dto.id,
      name: dto.businessName,
      description: '',
      opening_hours: '',
      nearby_cities: '',
      meta_title: '',
      meta_description: '',
      paypal_client_id: '',
      show_widget_filters: false,
      nexi_merchant: '',
      nexi_chiavemac: '',
      created_at: '',
      updated_at: '',
      max_experience_title_length: 0,
      place: { city: dto.city } as Place
    };
  }
  
}
